import Router from './router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Notifications from './components/ui/notifications';
import { useDispatch } from 'react-redux';
import { initialise, validateAuthToken } from './actions/login';
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initialise());
    const intervalId = setInterval(() => {
      dispatch(validateAuthToken());
    }, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  let cspString = `default-src 'self'; font-src 'self' https://fonts.gstatic.com data:;script-src 'self' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; style-src 'unsafe-inline' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; img-src 'self' data: https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; connect-src https://*.amazonaws.com https://api-js.mixpanel.com https://*.beekin.co;`;

  if (process.env.NODE_ENV === 'development') {
    cspString = `default-src 'self'; font-src 'self' https://fonts.gstatic.com https://d2twymdrqimvrw.cloudfront.net data:; script-src 'self' 'unsafe-inline' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; style-src 'unsafe-inline' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; img-src 'self' data: https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; connect-src http://localhost:* https://*.amazonaws.com https://api-js.mixpanel.com;`;
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta http-equiv="Content-Security-Policy" content={cspString}></meta>
        <meta http-equiv="X-Content-Type-Options" content="nosniff"></meta>
        <meta http-equiv="Referrer-Policy" content="no-referrer"></meta>
        <meta
          http-equiv="Feature-Policy"
          content="microphone none; geolocation none; camera none;"
        ></meta>
      </Helmet>
      <ToastContainer />
      <Notifications />
      <Router />
    </>
  );
};

export default App;
